import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DnaJobApplication } from '../models/dna-job-application.model';
import { ApiService } from '@app/shared/services/api.service';

@Injectable({ providedIn: 'root' })
export class DnaJobApplicationsService extends ApiService {
  constructor() {
    super();
    this.url = 'applications';
  }

  getApplications(): Observable<DnaJobApplication[]> {
    return this.get();
  }
}
